module.exports = __webpack_public_path__ + "static/media/movimientos.680c3552.svg";